import * as z from 'zod'

export const sectorFormSchema = z.object({
  title: z.string().min(2, 'Title must be at least 2 characters'),
  description: z.string().min(10, 'Description must be at least 10 characters'),
  icon_name: z.string().min(1, 'Select an icon'),
  slug: z
    .string()
    .min(2, 'Slug required')
    .regex(/^[a-z0-9-]+$/, 'Slug must be lowercase with dashes'),
  image_url: z.string().nullable().optional(),
  sort_order: z.coerce.number().int().default(0),

  // Nested page_content
  hero_title: z.string().min(1, 'Hero title required'),
  hero_cta: z.string().min(1, 'CTA text required'),

  // SEO
  seo_title: z.string().optional(),
  seo_description: z.string().optional(),
  seo_keywords: z.string().optional(),

  // Dynamic Lists
  problems: z.array(z.object({ value: z.string().min(1) })),
  ai_capabilities: z.array(z.object({ value: z.string().min(1) })),
  saas_examples: z.array(
    z.object({
      name: z.string().min(1),
      description: z.string().min(1),
      benefit: z.string().min(1),
    }),
  ),
  business_impact: z.array(
    z.object({
      label: z.string().min(1),
      value: z.string().min(1),
    }),
  ),

  // Form Config
  show_employee_count: z.boolean().default(true),
  show_uses_excel: z.boolean().default(true),
  custom_challenge_label: z.string().optional(),
})

export type SectorFormValues = z.infer<typeof sectorFormSchema>
